import { Image } from "react-native";

import { createStyles } from "../theme";
import { Col, Icon } from "../lib";

type Props = {
  uri?: string;
  small?: boolean;
};

export function Avatar({ uri, small = false }: Props) {
  const styles = [$.container, small && $.small];

  if (uri) {
    // @ts-ignore
    return <Image style={styles} source={{ uri }} />;
  }

  styles.push($.empty);

  return (
    <Col.C style={styles}>
      <Icon name="camera" color="onSurfaceDim" />
    </Col.C>
  );
}

export const AVATAR_SIZE = 160;

export const AVATAR_SIZE_SMALL = 60;

const $ = createStyles({
  container: {
    borderWidth: 4,
    borderColor: "transparent",
    width: AVATAR_SIZE,
    height: AVATAR_SIZE,
    borderRadius: "9999",
  },
  small: {
    width: AVATAR_SIZE_SMALL,
    height: AVATAR_SIZE_SMALL,
  },
  empty: {
    backgroundColor: "surface",
    borderColor: "outline",
  },
});

export const avatarStyles = $;
